module.exports = {
          srcSet: __webpack_public_path__ + "d598b445e12d005c31b225f2b83edd00-316.png"+" 316w",
          images:[ {path: __webpack_public_path__ + "d598b445e12d005c31b225f2b83edd00-316.png",width: 316,height: 115}],
          src: __webpack_public_path__ + "d598b445e12d005c31b225f2b83edd00-316.png",
          toString:function(){return __webpack_public_path__ + "d598b445e12d005c31b225f2b83edd00-316.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAECAYAAAC3OK7NAAAACXBIWXMAACWfAAAlnwFTj7bXAAAAXElEQVR4nE3OOwqDYBBF4a/KBgTTaSUWJig+UAzpUmUL2UA2kb2HgSn+6S73HO7ADwe+GNFm3nFR3Acr3ljQ4JnwgBlVgGEGEMKEKx7osRW9M+fCvKPOF26ZX+j+jWwHvMyoQ9wAAAAASUVORK5CYII=",
          width: 316,
          height: 115
        }